import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Card } from 'react-bootstrap';
import '../styles/Contacto.css';
import Axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Modal } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';
import { TailSpin } from 'react-loader-spinner';
import { MultiSelect } from "react-multi-select-component";
import Select from 'react-select';

function Contacto() {
    const [privacyAccepted, setPrivacyAccepted] = useState(false);
    const [urlParam, setUrlParam] = useState('');
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [company, setCompany] = useState('');
    const [errors, setErrors] = useState({});
    const [selectedOrigen, setSelectedOrigen] = useState("");
    const [selectedPais, setSelectedPais] = useState('España');
    const [cargo, setCargo] = useState('');
    const [done, setDone] = useState(false);
    const URL_DOMAIN = process.env.REACT_APP_URL_DOMAIN;
    const SITE_KEY = process.env.REACT_APP_reCAPTCHA_SITE_KEY;
    const captchaRef = useRef(null);
    const [selected, setSelected] = useState([]);
    const [selected1, setSelected1] = useState([]);
    const [showAllFields, setShowAllFields] = useState(false);

    // Get the first URL parameter on component mount
    useEffect(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const firstParam = urlParams.entries().next().value;
        if (firstParam) {
            setUrlParam(firstParam[1]); // firstParam[1] contains the value
        }
    }, []);

    const validateEmail = (email) => {
        const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        return regex.test(email);
    };

    const options = [
        { label: "Recetas y Escandallos", value: "90" },
        { label: "Compras", value: "91" },
        { label: "Ventas", value: "92" },
        { label: "Foodcost/Analisis de datos", value: "93" },
        { label: "Almacenes/Inventarios", value: "94" },
        { label: "Trazabilidad", value: "95" },
        { label: "Producción/Planificación", value: "96" },
        { label: "Etiquetado", value: "97" },
        { label: "Buffets", value: "98" },
    ];

    const origen = [
        { label: "Linkedin", value: "116" },
        { label: "Instagram", value: "117" },
        { label: "Distribuidores", value: "118" },
        { label: "Recomendado", value: "119" },
        { label: "Talent Class", value: "120" },
        { label: "BCC", value: "121" },
        { label: "Google Ad", value: "122" },
        { value: "168", label: "Youtube" },
        { value: "169", label: "Buscadores Web" },
        { value: "170", label: "Ferias" },
        { value: "171", label: "Internet" },
        { value: "172", label: "Intercom" },
        { label: "Otros", value: "123" },
    ];

    const [showModal, setShowModal] = useState(false);

    const openModal = () => {
        setShowModal(true);
    };
   
    const closeModal = () => {
        setShowModal(false);
        window.location.reload();
    };

    useEffect(() => {
        if(localStorage.getItem('key')){
            window.location.replace("https://app.tspoonlab.com/recipes/app/_/demo");
        }
    }, []);
      
    const options1 = [
        { label: "Restaurante", value: "17" },
        { label: "Cadena Restauración", value: "44" },
        { label: "Hotel", value: "18" },
        { label: "Hotel con Buffet", value: "19" },
        { label: "Cadena Hotelera", value: "45" },
        { label: "Dark Kitchen", value: "20" },
        { label: "Cocina Central", value: "22" },
        { label: "Eventos-Catering", value: "21" },
        { label: "Obrador Pasteleria", value: "23" },
        { label: "Industria", value: "24" },
        { label: "Tienda Online", value: "47" },
        { label: "Tienda de Comidas", value: "48" },
    ];

    const pais = [
        { label: "España", value: "1" },
        { label: "Portugal", value: "2" },
        { label: "Francia", value: "3" },
        { label: "Italia", value: "4" },
        { label: "Alemania", value: "5" },
        { label: "Reino Unido", value: "6" },
        { label: "Irlanda", value: "7" },
        { label: "Suecia", value: "8" },
        { label: "Noruega", value: "9" },
        { label: "Dinamarca", value: "10" },
        { label: "Finlandia", value: "11" },
        { label: "Holanda", value: "12" },
        { label: "Bélgica", value: "13" },
        { label: "Luxemburgo", value: "14" },
        { label: "Suiza", value: "15" },
        { label: "Austria", value: "16" },
        { label: "Polonia", value: "17" },
        { label: "República Checa", value: "18" },
        { label: "Eslovaquia", value: "19" },
        { label: "Hungría", value: "20" },
        { label: "Rumania", value: "21" },
        { label: "Bulgaria", value: "22" },
        { label: "Grecia", value: "23" },
        { label: "Turquía", value: "24" },
        { label: "Rusia", value: "25" },
        { label: "Ucrania", value: "26" },
        { label: "Estonia", value: "27" },
        { label: "Letonia", value: "28" },
        { label: "Lituania", value: "29" },
        { label: "Croacia", value: "30" },
        { label: "Eslovenia", value: "31" },
        { label: "Bosnia-Herzegovina", value: "32" },
        { label: "Serbia", value: "33" },
        { label: "Montenegro", value: "34" },
        { label: "Albania", value: "35" },
        { label: "Macedonia", value: "36" },
        { label: "Kosovo", value: "37" },
        { label: "Chipre", value: "38" },
        { label: "Malta", value: "39" },
        { label: "Andorra", value: "40" },
        { label: "Gibraltar", value: "41" },
        { label: "Mónaco", value: "42" },
        { label: "Vaticano", value: "43" },
        { label: "Estados Unidos", value: "44" },
        { label: "Canadá", value: "45" },
        { label: "México", value: "46" },
        { label: "Brasil", value: "47" },
        { label: "Argentina", value: "48" },
        { label: "Chile", value: "49" },
        { label: "Colombia", value: "50" },
        { label: "Perú", value: "51" },
        { label: "Venezuela", value: "52" },
        { label: "Ecuador", value: "53" },
        { label: "Uruguay", value: "54" },
        { label: "Paraguay", value: "55" },
        { label: "Bolivia", value: "56" },
        { label: "Guatemala", value: "57" },
        { label: "Honduras", value: "58" },
        { label: "El Salvador", value: "59" },
        { label: "Nicaragua", value: "60" },
        { label: "Costa Rica", value: "61" },
        { label: "Panamá", value: "62" },
        { label: "Cuba", value: "63" },
        { label: "Puerto Rico", value: "64" },
        { label: "República Dominicana", value: "65" },
        { label: "Jamaica", value: "66" },
        { label: "Trinidad y Tobago", value: "67" },
        { label: "Barbados", value: "68" },
        { label: "Granada", value: "69" },
        { label: "Antigua y Barbuda", value: "70" },
        { label: "San Cristóbal y Nieves", value: "71" },
        { label: "Santa Lucía", value: "72" },
        { label: "San Vicente y las Granadinas", value: "73" },
        { label: "Haití", value: "74" },
        { label: "Bahamas", value: "75" },
        { label: "Dominica", value: "76" },
        { label: "Belice", value: "77" },
        { label: "Guyana", value: "78" },
        { label: "Surinam", value: "79" },
        { label: "Guyana Francesa", value: "80" },
        { label: "Guayana", value: "81" },
        { label: "Australia", value: "82" },
        { label: "Nueva Zelanda", value: "83" },
        { label: "Fiyi", value: "84" },
        { label: "Papúa Nueva Guinea", value: "85" },
        { label: "Islas Salomón", value: "86" },
        { label: "Vanuatu", value: "87" },
        { label: "Samoa", value: "88" },
        { label: "Kiribati", value: "89" },
        { label: "Tonga", value: "90" },
        { label: "Micronesia", value: "91" },
        { label: "Islas Marshall", value: "92" },
        { label: "Nauru", value: "93" },
        { label: "Tuvalu", value: "94" },
        { label: "Palau", value: "95" },
        { label: "Islas Cook", value: "96" },
        { label: "Niue", value: "97" },
        { label: "Tokelau", value: "98" },
        { label: "Samoa Americana", value: "99" },
        { label: "Polinesia Francesa", value: "100" },
        { label: "Nueva Caledonia", value: "101" },
        { label: "Wallis y Futuna", value: "102" },
        { label: "Tahití", value: "103" },
        { label: "Islas Pitcairn", value: "104" },
        { label: "Guam", value: "105" },
        { label: "Islas Marianas del Norte", value: "106" },
        { label: "Islas Midway", value: "107" },
        { label: "Islas Wake", value: "108" },
        { label: "Hawai", value: "109" },
        { label: "Alaska", value: "110" },
        { label: "Groenlandia", value: "111" },
        { label: "Svalbard y Jan Mayen", value: "112" },
        { label: "Islas Feroe", value: "113" },
    ];

    const handleSubmit = async (event) => {
        event.preventDefault();

        const errors = {};

        // Basic validations that apply to all countries
        if (!name.trim()) {
            errors.name = 'El nombre es obligatorio';
        }
        if (!surname.trim()) {
            errors.surname = 'Los apellidos son obligatorios';
        }
        if (!email.trim()) {
            errors.email = 'El correo electrónico es obligatorio';
        } else if (!validateEmail(email)) {
            errors.email = 'El correo electrónico no es válido';
        }
        if (!phone.trim()) {
            errors.phone = 'El teléfono es obligatorio';
        }
        if (!company.trim()) {
            errors.company = 'La empresa es obligatoria';
        }
        if (!privacyAccepted) {
            errors.privacy = 'Debes aceptar la política de privacidad';
        }

        // Additional validations for countries outside España, Portugal, and Andorra
        if (showAllFields) {
            if (!cargo.trim()) {
                errors.cargo = 'El cargo es obligatorio';
            }
            if (!selectedOrigen) {
                errors.origen = 'Por favor, selecciona una opción';
            }
        }

        if (Object.keys(errors).length > 0) {
            setErrors(errors);
        } else {
            openModal();

            let token = captchaRef.current.getValue();
            captchaRef.current.reset();
            if (token) {
                let valid_token = await verifyToken(token);

                if (valid_token.success === true) {
                    // Set cookies accessible to .tspoonlab.com domain
                    const cookieOptions = 'domain=.tspoonlab.com; path=/; max-age=31536000; SameSite=Lax; Secure'; // 1 year expiration
                    document.cookie = `nombre=${encodeURIComponent(name)}; ${cookieOptions}`;
                    document.cookie = `apellidos=${encodeURIComponent(surname)}; ${cookieOptions}`;
                    document.cookie = `email=${encodeURIComponent(email)}; ${cookieOptions}`;
                    document.cookie = `empresa=${encodeURIComponent(company)}; ${cookieOptions}`;
                    console.log("verified");
                    
                    // Fire GTM custom event with URL parameter data
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'form_submission_success',
                            form_type: 'cuenta_demo',
                            traffic_source: urlParam || 'DEMOWEB',
                            user_country: selectedPais,
                            user_email: email,
                            user_company: company
                        });
                        
                        // Fire specific event for each URL parameter
                        if (urlParam) {
                            window.dataLayer.push({
                                event: `conversion_${urlParam.toLowerCase()}`,
                                traffic_source: urlParam,
                                conversion_type: 'demo_form_completed'
                            });
                        }

                        // Google Ads Conversion Tracking
                        window.dataLayer.push({
                            event: 'google_ads_conversion',
                            conversion_id: '947967558',
                            conversion_label: 'pHVnCLe96ogbEMasg8QD',
                            traffic_source: urlParam || 'DEMOWEB'
                        });
                    }

                    // Meta Pixel Lead Event
                    if (window.fbq) {
                        window.fbq('track', 'Lead', {
                            source: urlParam || 'DEMOWEB',
                            content_name: 'Demo Account Registration',
                            value: 1.00,
                            currency: 'EUR'
                        });
                        console.log('Meta Pixel Lead event fired for source:', urlParam || 'DEMOWEB');
                    }

                    // Google Ads Global Site Tag Conversion (fallback)
                    if (window.gtag) {
                        window.gtag('event', 'conversion', {
                            'send_to': '947967558/pHVnCLe96ogbEMasg8QD',
                            'transaction_id': email + '_' + Date.now(),
                            'custom_parameter': urlParam || 'DEMOWEB'
                        });
                        console.log('Google Ads conversion fired for source:', urlParam || 'DEMOWEB');
                    }
                    
                    setName('');
                    setSurname('');
                    setEmail('');
                    setPhone('');
                    setCompany('');
                    
                    setErrors({});
                    setDone(true)
                    localStorage.setItem('key','key')
                    window.location.replace("https://app.tspoonlab.com/recipes/app/_/demo");
                } else {
                    console.log("not verified");
                }
            }
        }
    };

    const verifyToken = async (token) => {
        const negocios = selected1.map(item => item.value).join(",");
        const preferencias = selected.map(item => item.value).join(",");
        const response = await fetch(URL_DOMAIN+'/verify-token-cuenta-demo', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name: name,
                surname: surname,
                email: email,
                phone: phone,
                company: company,
                cargo: cargo,
                options: showAllFields ? negocios : '',
                options1: showAllFields ? preferencias : '',
                origen: showAllFields ? selectedOrigen : '',
                message: '',
                pais: selectedPais,
                urlParam: urlParam,
                token: token,
                website: '' // Honeypot field - should always be empty
            }), 
        });
          
        if (response.ok) {
            const data = await response.json();
            return data;
        }
    };

    useEffect(() => {
        setShowAllFields(!['España', 'Portugal', 'Andorra'].includes(selectedPais));
    }, [selectedPais]);

    const customStyles = {
        control: (provided) => ({
            ...provided,
            backgroundColor: '#f1f1f1',
            borderRadius: 0,
            borderTop: 'none',
            borderLeft: 'none',
            borderRight: 'none',
            borderBottom: '1px solid #ccc',
            boxShadow: 'none',
            '&:hover': {
                borderColor: '#ee3750',
            }
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#646464',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#646464',
        }),
    };

    return (
        <Container fluid className="bg-light py-5">
            <Row className="justify-content-center">
                <Col xs={12} md={10} lg={8}>
                    <Card className="contact-form-container">
                        <Card.Body>
                            <h1 className="text-center text-ee3750 mb-4">Formulario Cuenta Demo</h1>
                            <div className="text-center mb-5">
                                <h2 className="h4 mb-3 font-weight-bold">Bienvenido a tSpoonLab:</h2>
                                <p className="mb-3">En nuestra Cuenta Demo podrás ver en directo y trabajar:</p>
                                <ul className="list-unstyled">
                                    <li className="mb-2">
                                        🚀🌍 Los Escandallos Más Completos del Mundo.
                                    </li>
                                    <li className="mb-2">
                                        🛒💰 Conocer el Proceso de gestión de Compras para bajar tus costes.
                                    </li>
                                    <li className="mb-2">
                                        📊 Ver informes en Tiempo Real para tomar decisiones estratégicas.
                                    </li>
                                </ul>
                                <p className="font-weight-bold mt-3">Te esperamos</p>
                            </div>
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col xs={12} md={6} className="mb-3">
                                        <h6>Nombre</h6>
                                        <Form.Control
                                            type="text"
                                            placeholder="Tu nombre"
                                            value={name}
                                            onChange={(event) => setName(event.target.value)}
                                            isInvalid={errors.name}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                                    </Col>
                                    <Col xs={12} md={6} className="mb-3">
                                        <h6>Apellidos</h6>
                                        <Form.Control
                                            type="text"
                                            placeholder="Tus apellidos"
                                            value={surname}
                                            onChange={(event) => setSurname(event.target.value)}
                                            isInvalid={errors.surname}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.surname}</Form.Control.Feedback>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={12} md={6} className="mb-3">
                                        <h6>Email</h6>
                                        <Form.Control
                                            type="email"
                                            placeholder="Tu email"
                                            value={email}
                                            onChange={(event) => setEmail(event.target.value)}
                                            isInvalid={errors.email}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                                    </Col>
                                    <Col xs={12} md={6} className="mb-3">
                                        <h6>Teléfono</h6>
                                        <Form.Control
                                            type="tel"
                                            placeholder="Tu teléfono"
                                            value={phone}
                                            onChange={(event) => setPhone(event.target.value)}
                                            isInvalid={errors.phone}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.phone}</Form.Control.Feedback>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col xs={12}>
                                        <h6>País</h6>
                                        <Select 
                                            value={pais.find((option) => option.label === selectedPais)}
                                            onChange={(selectedOption) => setSelectedPais(selectedOption.label)}
                                            options={pais} 
                                            styles={customStyles} 
                                            isRequired
                                        />  
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={12} md={6} className="mb-3">
                                        <h6>Empresa</h6>
                                        <Form.Control
                                            type="text"
                                            placeholder="Nombre de la empresa"
                                            value={company}
                                            onChange={(event) => setCompany(event.target.value)}
                                            isInvalid={errors.company}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.company}</Form.Control.Feedback>
                                    </Col>
                                    <Col xs={12} md={6} className="mb-3">
                                        <h6>Cargo</h6>
                                        <Form.Control
                                            type="text"
                                            placeholder="Tu cargo"
                                            value={cargo}
                                            onChange={(event) => setCargo(event.target.value)}
                                            isInvalid={errors.cargo}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.cargo}</Form.Control.Feedback>
                                    </Col>
                                </Row>

                                {showAllFields && (
                                    <>
                                        <Row className="mb-3">
                                            <Col xs={12} md={6}>
                                                <Form.Group controlId="formNegocio">
                                                    <h6>Tipo de Negocio</h6>
                                                    <MultiSelect
                                                        options={options1}
                                                        value={selected1}
                                                        onChange={setSelected1}
                                                        labelledBy="Select"
                                                        hasSelectAll={false}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} md={6}>
                                                <Form.Group controlId="formIntereses">
                                                    <h6>¿Qué te interesa controlar?</h6>
                                                    <MultiSelect
                                                        options={options}
                                                        value={selected}
                                                        onChange={setSelected}
                                                        labelledBy="Select"
                                                        hasSelectAll={false}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col xs={12}>
                                                <Form.Group controlId="formOrigen">
                                                    <h6>¿Dónde nos conociste?</h6>
                                                    <Select 
                                                        value={origen.find((option) => option.value === selectedOrigen)}
                                                        onChange={(selectedOption) => setSelectedOrigen(selectedOption.value)}
                                                        options={origen} 
                                                        styles={customStyles} 
                                                        isRequired
                                                    />  
                                                    {errors.origen && <div className="text-danger">{errors.origen}</div>}
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </>
                                )}

                                <Row className="mb-3">
                                    <Col xs={12}>
                                        <Form.Check 
                                            type="checkbox"
                                            id="privacyCheck"
                                            checked={privacyAccepted}
                                            onChange={(e) => setPrivacyAccepted(e.target.checked)}
                                            isInvalid={!!errors.privacy}
                                            label={
                                                <span>

He leído y acepto el <a href="https://www.tspoonlab.com/politica-de-privacidad/" target="_blank" rel="noopener noreferrer" className="text-ee3750">Aviso legal y la Política de privacidad.</a>*

                                                </span>
                                            }
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.privacy}</Form.Control.Feedback>
                                    </Col>
                                </Row>

                                <Row className="mb-4">
                                    <Col xs={12} className="d-flex justify-content-center recaptcha">
                                        <ReCAPTCHA 
                                            sitekey='6LdtGdUlAAAAAIi0Np497UZOROW0sbDyhpaT562_' 
                                            ref={captchaRef}
                                        />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={12} className="d-flex justify-content-center">
                                        <Button variant="primary" className="bg-ee3750" type="submit">
                                            Enviar
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>

                    <Row className="mt-4">
                        <Col xs={12}>
                            <p className="text-muted" style={{ fontSize: '0.8rem', lineHeight: '1.4' }}>
                                tSpoonLab te informa de que los datos de carácter personal que nos proporciones en nuestros formularios de contacto en la web, serán tratados únicamente por tSpoonLab s,l como responsable de esta web. La finalidad de la recogida y tratamiento de los datos personales será para informarte sobre nuestros servicios y recursos exclusivos, así como de nuestras ofertas y campañas espaciales. La legitimación se realizará a través del consentimiento del interesado. Te informamos que los datos que nos facilitas estarán ubicados en los servidores de <a href="https://www.activecampaign.com/" target="_blank" rel="noopener noreferrer" className="text-ee3750">"Active Campaign"</a> (proveedor de mail marketing, ubicado en EEUU y acogido al EU-US PrivacyShield). Ver <a href="https://www.activecampaign.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-ee3750">"Política privacidad de Active Campaign"</a>. El hecho de no introducir íntegramente los datos requeridos en los formularios puede dar lugar a que no podamos proporcionar el servicio ofertado o no podamos atender a su solicitud. Podrás ejercer tus derechos de acceso, rectificación, limitación y eliminación de tus datos escribiendo mail a rafel@tspoonlab.com, así como el derecho a presentar una reclamación ante una autoridad de control. Puedes consultar nuestra <a href="https://www.tspoonlab.com/politica-de-privacidad/" target="_blank" rel="noopener noreferrer" className="text-ee3750">"política de privacidad tSpoonLab S,L"</a>.
                            </p>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Modal show={showModal} onHide={closeModal}>
                <Modal.Body>
                    {!done && (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '50vh',
                            }}
                        >
                            <TailSpin
                                height="160"
                                width="160"
                                color="#ee3750"
                                ariaLabel="tail-spin-loading"
                                radius="1"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={true}
                            />
                        </div>
                    )}

                    {done && <h1>"Redirigiendo..."</h1>}
                </Modal.Body>
                <Modal.Footer>
                    {done && (
                        <Button variant="secondary" onClick={closeModal}>
                            Volver
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </Container>
    );
}

export default Contacto;